import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_message.svg';
import Icon, { IconProps } from './icon';

const IconMessage = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconMessage;
